import PropTypes from "prop-types";

import React from "react";
import Microsoft from "lib/microsoft";

import CustomLoginButton from "UIComponents/CustomLoginButton";
import CustomLoginBoxButton from "UIComponents/CustomLoginBoxButton";

import { isInKioskMode } from "Utils/DeviceDetectHelpers";
import { openSelfLoginWindow } from "Login/modules/LoginModule";
import { MicrosoftColored, Microsoft3D } from "@toddle-edu/ds-icons";

class MicrosoftLoginBtn extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  onBtnClick = () => {
    if (isInKioskMode()) {
      openSelfLoginWindow("MICROSOFT");
    } else {
      this.loginPopup();
    }
  };

  loginPopup = async () => {
    const { onSuccess, onFailure } = this.props;

    await Microsoft.loginPopup({
      successCallback: accessToken => {
        if (onSuccess) {
          onSuccess(accessToken);
        }
      },
      failureCallback: err => {
        if (onFailure) {
          onFailure(err);
        }
      },
    });
  };

  render() {
    const { isBoxButton, innerConStyle, containerStyle } = this.props;

    return (
      <div>
        {isBoxButton ? (
          <CustomLoginBoxButton
            data-test-id={"button-login-microsoft"}
            icon={<Microsoft3D height={88} width={88} />}
            buttonText={"Microsoft"}
            onClick={this.onBtnClick}
          />
        ) : (
          <CustomLoginButton
            data-test-id={"button-login-microsoft"}
            icon={<MicrosoftColored size="x-small" />}
            buttonText={"Microsoft"}
            onClick={this.onBtnClick}
            innerConStyle={innerConStyle}
            containerStyle={containerStyle}
          />
        )}
      </div>
    );
  }
}

MicrosoftLoginBtn.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  isBoxButton: PropTypes.bool,
};

MicrosoftLoginBtn.defaultProps = {
  isBoxButton: false,
};

export default MicrosoftLoginBtn;
